import React, { useCallback, useEffect, useState } from 'react';
import { useServices } from './ServiceProvider';
import { useDispatch, useSelector } from 'react-redux';
import { Box, IconButton, Snackbar, Stack, Typography, useTheme } from '@mui/material';
import { Icon } from '../core/icon';
import { renderIcon } from './renderIcon';
const getLevelColor = (level) => {
    if (level === 'error')
        return '#aa2e25';
    if (level === 'warn')
        return '#ffac33';
    return '#bdbdbd';
};
const getLevelIcon = (level) => {
    const props = { sx: { color: getLevelColor(level), marginRight: '0.5em' } };
    if (level === 'error')
        return renderIcon(Icon.ERROR, { ...props, fontSize: 'large' });
    if (level === 'warn')
        return renderIcon(Icon.WARNING, { ...props, fontSize: 'large' });
    return renderIcon(Icon.INFO, { ...props, fontSize: 'large' });
};
const getAutoHideDuration = (level) => level === 'info' ? 5e3 : null;
const AppWideNotifications = () => {
    const { NotificationsService } = useServices();
    const dispatch = useDispatch();
    const latestStoredNotification = useSelector(NotificationsService.getLatestNotification);
    const [currentNotificationID, setCurrentNotificationID] = useState(latestStoredNotification?.id);
    const currentNotification = useSelector((state) => (currentNotificationID
        ? NotificationsService.getNotificationByID(state, currentNotificationID)
        : undefined));
    useEffect(() => {
        if ((!currentNotificationID)
            || (currentNotificationID !== latestStoredNotification?.id && currentNotification?.acknowledged)) {
            setCurrentNotificationID(latestStoredNotification?.id);
        }
    }, [
        currentNotificationID !== latestStoredNotification?.id,
        currentNotification?.acknowledged
    ]);
    const onClose = useCallback(() => currentNotification && dispatch(NotificationsService.acknowledgeNotification(currentNotification.id)), [currentNotification]);
    const theme = useTheme();
    return currentNotification && (React.createElement(Snackbar, { key: currentNotification.id, open: !currentNotification.acknowledged, onClose: onClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, autoHideDuration: getAutoHideDuration(currentNotification.level), 
        // slots={{ transition: (props: SlideProps) => <Slide {...props} direction="up"/>}}
        slotProps: {
            root: { sx: { maxWidth: '50vw' } },
            content: {
                sx: {
                    backgroundColor: theme.palette.background.paper,
                    boxSizing: 'border-box',
                    border: '1px solid #444',
                    borderLeft: `0.5em solid ${getLevelColor(currentNotification.level)}`,
                }
            }
        }, message: (React.createElement(Box, { color: theme.palette.text.primary },
            React.createElement(Stack, { direction: "row", alignItems: "center", sx: { marginBottom: '0.25em' } },
                getLevelIcon(currentNotification.level),
                React.createElement(Typography, { variant: "body1" }, currentNotification.title)),
            React.createElement(Typography, { variant: "body2" }, currentNotification.body))), action: (React.createElement(IconButton, { size: "small", "aria-label": "close", color: "default", onClick: onClose }, renderIcon(Icon.CLOSE, { fontSize: 'small' }))) }));
};
export default AppWideNotifications;
//# sourceMappingURL=AppWideNotifications.js.map